import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FiChevronUp, FiChevronDown } from 'react-icons/fi';

const NEAR_EDGE_PX = 80;

export default function ScrollControls() {
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  useEffect(() => {
    const update = () => {
      const { scrollY, innerHeight } = window;
      const documentHeight = document.documentElement.scrollHeight;
      const isScrollable = documentHeight > innerHeight + NEAR_EDGE_PX;

      setCanScrollUp(isScrollable && scrollY > NEAR_EDGE_PX);
      setCanScrollDown(isScrollable && scrollY + innerHeight < documentHeight - NEAR_EDGE_PX);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const scrollToBottom = () =>
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });

  const buttonClass =
    'flex h-11 w-11 items-center justify-center rounded-full border border-line bg-white/90 text-muted shadow-card backdrop-blur transition hover:border-brand-300 hover:text-brand-600 dark:border-midnight-600 dark:bg-midnight-700/90 dark:text-subtle dark:hover:border-brand-500 dark:hover:text-brand-300';

  return (
    <div className="fixed right-5 bottom-6 z-40 flex flex-col gap-3 sm:right-6">
      <AnimatePresence>
        {canScrollUp && (
          <motion.button
            key="scroll-up"
            type="button"
            onClick={scrollToTop}
            aria-label="Scroll to top"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.2 }}
            className={buttonClass}
          >
            <FiChevronUp size={20} />
          </motion.button>
        )}
        {canScrollDown && (
          <motion.button
            key="scroll-down"
            type="button"
            onClick={scrollToBottom}
            aria-label="Scroll to bottom"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className={buttonClass}
          >
            <FiChevronDown size={20} />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}
